<template>
  <div>
    <div v-if="layoutData.label != null" class="row">
      <div class="col-md-5 col-sm-5 col-xs-5 text-right" style="font-weight: bold; padding-right: 0; padding-left: 0; margin-top:5px; text-decoration: underline">{{layoutData.label}}</div>
      <div class="col-md-7 col-sm-7 col-xs-7 text-right">
      </div>
    </div>
    <timesheet-fieldset v-for="(field, index) in enabledFields" :key="index" :layout="field" @change="onChange" />
  </div>
</template>

<script>
  export default {
    components: { 
      TimesheetFieldset: () => import('../TimesheetFieldset.vue')
    },
    name: "timesheet-group-basic",
    props: {
      layout: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        layoutData: this.layout
      }
    },
    computed: {
      enabledFields() {
        return this.layoutData.fields.filter(e => e.enabled !== false); 
      },
    },
    methods: {
      onChange(e,l,v,i) {
        this.$emit("change", e, l, v, i)
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>